import * as React from "react";
import { Input, Button, Row, Col } from "antd";
import { MailOutlined, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { IPasswordResetCredentials } from "../../../model/authentication/PasswordResetCredentials";
import ErrorMessage from "../ErrorMessage";
import Text from "antd/lib/typography/Text";

const PasswordResetForm = ({
  translate,
  credentials,
  setCredentialsValue,
  resetPassword,
  resetPasswordDisabled = false,
  loading,
  validationErrors
}: {
  translate: any;
  credentials: IPasswordResetCredentials;
  setCredentialsValue: (name: string, value: string) => void;
  resetPassword: () => Promise<void>;
  resetPasswordDisabled?: boolean;
  loading: boolean;
  validationErrors?: any;
}) => {
  const styles = {
    fieldContainer: { marginTop: 10, marginBottom: 10 },
    buttonContainer: {
      marginTop: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };

  return (
    <React.Fragment>
      <Row className={"modified-wrapper"}>
        <Col lg={15} sm={24} xs={24}>
          <div className="content-container">
            <div className="content-section">
              <Row className={"group-items"} style={styles.fieldContainer}>
                <Text className={"label"}>
                  {translate("password_reset.username")}
                </Text>
                <Input
                  className={"input"}
                  placeholder={translate("password_reset.username_placeholder")}
                  prefix={<UserOutlined />}
                  allowClear={true}
                  value={credentials.username}
                  onChange={(e) =>
                    setCredentialsValue("username", e.target.value)
                  }
                  autoFocus={true}
                />
                {validationErrors && validationErrors["username"] ? (
                  <ErrorMessage errors={validationErrors["username"]} />
                ) : null}
              </Row>
              <Row className={"group-items"} style={styles.fieldContainer}>
                <Text className={"label"}>
                  {translate("password_reset.email")}
                </Text>
                <Input
                  className={"input"}
                  placeholder={translate("password_reset.email_placeholder")}
                  prefix={<MailOutlined />}
                  allowClear={true}
                  value={credentials.email}
                  onChange={(e) => setCredentialsValue("email", e.target.value)}
                />
                {validationErrors && validationErrors["email"] ? (
                  <ErrorMessage errors={validationErrors["email"]} />
                ) : null}
              </Row>
              <Row className={"group-items"} style={styles.fieldContainer}>
                <Text className={"label"}>
                  {translate("password_reset.phone")}
                </Text>
                <Input
                  placeholder={translate("password_reset.phone_placeholder")}
                  className={"input"}
                  prefix={<PhoneOutlined />}
                  allowClear={true}
                  value={credentials.phone}
                  onChange={(e) => setCredentialsValue("phone", e.target.value)}
                />
                {validationErrors && validationErrors["phone"] ? (
                  <ErrorMessage errors={validationErrors["phone"]} />
                ) : null}
              </Row>
              <Row className={"group-items"} style={styles.buttonContainer}>
                <Button
                  className="button-primary"
                  key="submit"
                  onClick={resetPassword}
                  disabled={resetPasswordDisabled}
                  loading={loading}>
                  {translate("password_reset.submit_button")}
                </Button>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default PasswordResetForm;
